import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";


export default function Users() {
    return (
        <TableContainer overflowY={'scroll'}>
            <Table size='sm' variant={'striped'}>
                <Thead  position={'sticky'} top={'0%'} h={'30px'} bg={'primary.500'} alignItems={'flex-start'}>
                    <Tr>
                        <Th
                            color={'white'}
                        >
                            Name
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Email
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Access
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Role Status
                        </Th>
                        <Th
                            color={'white'}
                        >
                            Last Login Date
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    <Tr>
                        <Td colSpan={5} textAlign={'center'}>No data available in table</Td>
                    </Tr>
                </Tbody>
            </Table>
        </TableContainer>
    )
}